import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2">

                <a href="javascript:void(0)" onClick={(e) => {
                        e.preventDefault();
                        removeAll()
                    }} class="active-facets__button js-facet-remove active-facets__clear-all">
                    <span class="active-facets__button-inner px-15 py-[7px] flex text-ss-14 font-sans">Clear all</span>
                </a>
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <span class="active-facets__button-inner px-15 py-[7px] flex items-center gap-5 text-ss-14 font-sans border-1 border-black">
                        {filter.value}
                        <svg onClick={() => filter.remove()} aria-hidden="true" focusable="false" role="presentation" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
                           <path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                     </span>
                        // <div class="ns-selected-filter ns-d-flex ns-align-items-center ns-px-1 ns-mr-1 ns-mb-1 ns-font-4">
                        //     <span class="ns-color-black">
                        //         {filter.name}: {filter.value}
                        //     </span>
                        //     <FilterRemoveButton filter={filter} />
                        // </div>
                    ))}
                </div>
            </div>
        )
    )
}
